import { Component, ElementRef, OnInit } from '@angular/core';
import * as moment from 'moment';
import { PageBase } from 't4core';

@Component({
  selector: 'ClaimStatisticsComponent',
  templateUrl: './ClaimStatistics.html'
})
export class ClaimStatisticsComponent extends PageBase implements OnInit {
  public fromDate: moment.Moment = moment().startOf('month');
  public toDate: moment.Moment = moment().endOf('month');

  public claims: any[] = [];

  constructor(el: ElementRef) {
    super(el, "FleetManagement");
  }

  async ngOnInit() {
    await this.loadData();
  }
   
  public async loadData() {
    var token = this.UI.beginLoading('Turbo.OneWayAdmin.Claims.msgLoadingStatistics', 'Loading claim statistics', null);
    try {
      this.claims = await this.Api.get<any[]>("Service/GetClaimStatistics", { from: this.fromDate, to: this.toDate }) ?? [];

    } finally {
      this.UI.loaderCompleted(token);
    }
  }

  public formatDuration(minutes: number): string {
    if (!minutes) return '-';
    return Math.round(minutes / 1440) + 'd';
  }
}
